export default {
  masterChef: {
    4: '0xd9145CCE52D386f254917e481eB44e9943F39138',
    137: '0x56823FBB2Bfc1795AbA546F336ddf1c90cad38B3',
  },
  // placeholder address to deal with import errors later on
  // the contracts that use this address will NOT work as expected
  placeholder: {
    4: '',
    137: '',
  },
  multiCall: {
    4: '0x9bfB04535b6FD0CAB092A2b0780908cDCD8BB465',
    137: '0x274C9aa362B14dB72D7dBa900A026E0FCc19B59d',
  },
  referral: {
    4: '0x9bfB04535b6FD0CAB092A2b0780908cDCD8BB465',
    137: '0x5Ed123B3e9449959387eBd4fC6CE7ECbDf7e1ce5',
  },
  mvaultChef: {
    4: '',
    // this is for Auto and Burning vaults
    137: '0xd3B32225fd1008A492dec07cf426A809f65ee63A',
  },
  vaultChef: {
    4: '',
    137: '0xB0a674Ea11a2B90e07EECaeC1B4904274ec2FE63',
  },
  sushiMiniChef: {
    4: '',
    // polycat strategy chefs mini chef contracts
    137: '0x0769fd68dFb93167989C6f7254cd0D766Fb2841F',
  },
  sushiComplexRewarderTime: {
    4: '',
    // for the vaults that use sushiSwap strategy - used to find matic rewards
    137: '0xa3378Ca78633B3b9b2255EAa26748770211163AE',
  },
  miniApeV2: {
    // for vaults that use the ApeSwap
    4: '',
    137: '0x54aff400858Dcac39797a81894D9920f16972D1D',
  },
  apeComplexRewarderTime: {
    4: '',
    // for the vaults that use apeSwap strategy - used to find matic rewards
    137: '0x1F234B1b83e21Cb5e2b99b4E498fe70Ef2d6e3bf',
  },
  stakingRewards: {
    4: '',
    137: '',
  },
  polygonFarmMasterChef: {
    // native token is Spade
    4: '',
    137: '0x9A2C85eFBbE4DD93cc9a9c925Cea4A2b59c0db78',
  },
  // used to calculate token prices for vault apr for sushi, matic, and quick
  sushiUsdLp: {
    // used to calculate token prices for vault apr
    4: '',
    137: '0xE15E9d2a5af5c1d3524bBC594DDc4a7D80aD27CD',
  },
  maticUsdLp: {
    // used to calculate token prices for vault apr
    4: '',
    137: '0x6e7a5fafcec6bb1e78bae2a1f0b612012bf14827',
  },
  quickUsdLp: {
    // used to calculate token prices for vault apr
    4: '',
    137: '0x1F1E4c845183EF6d50E9609F16f6f9cAE43BC9Cb',
  },
  bananaWmaticLp: {
    // used to calculate token prices for vault apr
    4: '',
    137: '0x034293F21F1cCE5908BC605CE5850dF2b1059aC0',
  },
  spadeUsdLp: {
    // used to calculate token prices for vault apr
    4: '',
    137: '0x6Fd8aAe9f85A7Db14c45453daAB81aa3085E4bA3',
  },

}
